import { render, staticRenderFns } from "./view.html?vue&type=template&id=854ed55a&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=854ed55a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854ed55a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('854ed55a')) {
      api.createRecord('854ed55a', component.options)
    } else {
      api.reload('854ed55a', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=854ed55a&scoped=true&", function () {
      api.rerender('854ed55a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/gameInstanceBox/index.vue"
export default component.exports